module.exports = __webpack_public_path__ + "img/exportURL5.410c3ea9.png";